import { useAppSelector } from '../../../../../reduxService/hooks';
import { EProjectType } from '../../../../enum/project';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import StaticVertical from './StaticVertical';

interface IStaticResultsProps {}

const StaticResults = (props: IStaticResultsProps) => {
    const projectInfo = useAppSelector(selectProjectInfo);

    let canvas: JSX.Element;

    switch (projectInfo.data!.type) {
        case EProjectType.Macra2 | EProjectType.VerticalDrop:
            canvas = <StaticVertical />;
            break;
        default:
            canvas = <></>;
            break;
    }

    return canvas;
};

export default StaticResults;
